import { BottomSheet, Button, Card, Icon, List, Loader, PageLayout, Typography } from '@bharatpe/bharat-ui';
import AppHeader from 'components/atoms/AppHeader';
import Toasty from 'components/atoms/Toasty';
import useUpiStatus from 'Hooks/useUpiStatus';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	SET_HOME_MODAL_VISIBILITY,
	SET_ONBOARDING_REDIRECTION_PAGE,
	SET_UPI_STEP,
	useUpiData,
	useUpiStep,
} from 'Slices';
import { MODULE_DEEPLINKS, ONBOARDING_REDIRECTION_PAGE, UPISteps } from 'utils/CONSTANT';
import {
	checkPermissions,
	closeNativeSupport,
	copyToClipboard,
	customSubScribeBackButton,
	getURLParameter,
} from 'utils/nativeSupport';
import { isEmpty, isIOS, isProd } from 'utils/Utils';
import history from 'utils/History';
import { triggerUPIUserDetails, useUPIUserDetails } from 'Slices/GetUPIUserDetails';
import { triggerMerchantInfoApi, useMerchantInfo } from 'Slices/MercantInfoSlice';
import UPILogo from 'assets/icons/Autopay/UpiLogo.png';
import copyIcon from 'assets/icons/Autopay/copyIcon.svg';
import transactionHistoryIcon from 'assets/icons/Autopay/transactionHistoryIcon.svg';
import circleCheck from 'assets/icons/Autopay/circle-check.png';
import BankIcon from 'assets/icons/Autopay/BankIcon.svg';
import autoPayIcon from 'assets/icons/Autopay/autoPayIcon.svg';
import linkBroken from 'assets/icons/Autopay/linkBroken.svg';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { CheckCircle, WarningRounded, Error } from '@bharatpe/bharat-ui/web/Icons';
import { DelinkBharatPeUPI, openDeepLinkWithCallback } from 'utils/nativeUpiHandler';
import LoaderImage from '../../../assets/images/loader-bui.gif';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import { NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';
import AllModals from 'containers/UPIContainer/Modals';

const UPISettings: React.FC = () => {
	const dispatch = useDispatch();
	const [showDelinkUPIAccountDeniedModal, handleDelinkUPIAccountDeniedPrimaryButtonClick] = useState(false);

	const [showDelinkBharatPeUpiModal, setShowDelinkBharatPeUpiModal] = useState(false);
	const [showDelinkBharatPeUpiLoadingModal, setShowDelinkBharatPeUpiLoadingModal] = useState(false);
	const [showDelinkBharatPeUpiSuccessModal, setShowDelinkBharatPeUpiSuccessModal] = useState(false);
	const [showDelinkBharatPeUpiFailureModal, setShowDelinkBharatPeUpiFailureModal] = useState(false);
	const [delinkBharatPeUpiStatus, setDelinkBharatPeUpiStatus] = useState(false);
	const [countdownTimer, setCountDownTimer] = useState(5);
	const timeRef: any = useRef();
	const [startInterval, setStartInterval] = useState(false);
	const upiData = useUpiData();

	const merchantInfo = useMerchantInfo();
	const { merchantName } = merchantInfo?.data;
	const userDetails = useUPIUserDetails();
	const upiStatus = useUpiStatus(ONBOARDING_REDIRECTION_PAGE.PROFILE);
	const upiStepDetails = useUpiStep();
	const { languageData } = useLanguageConfig();

	const { va } = userDetails?.data?.user_banks?.[0] || [];
	const { profile_id, auto_pay_active } = userDetails?.data;

	useEffect(() => {
		if (startInterval) {
			timeRef.current = countdownTimer > 0 && setInterval(() => setCountDownTimer((time) => time - 1), 1000);
			if (countdownTimer == 0) {
				if (delinkBharatPeUpiStatus) {
					onBack();
				} else setShowDelinkBharatPeUpiFailureModal(false);
			}
		}
		return () => clearInterval(timeRef.current);
	}, [countdownTimer, startInterval]);

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page View',
			Product: 'AutoPayUPI',
			Flow: 'Setting',
			Screen: 'UPI_Settings',
			Module: 'Page',
			Action: 'Viewed',
		});
	}, []);

	useEffect(() => {
		if (isEmpty(userDetails.data) && userDetails?.loading == false) dispatch(triggerUPIUserDetails());
	}, [userDetails.data, dispatch]);

	useEffect(() => {
		if (isEmpty(merchantInfo.data) && merchantInfo?.loading == false) dispatch(triggerMerchantInfoApi());
	}, [merchantInfo.data, dispatch]);

	useEffect(() => {
		if ((upiStatus?.upiErr || upiStatus?.upiStep) && isEmpty(upiStepDetails) && !upiStatus?.loading) {
			dispatch(SET_UPI_STEP({ upiStep: upiStatus?.upiStep, upiErr: upiStatus?.upiErr, loading: upiStatus?.loading }));
		}
	}, [dispatch, upiStatus]);

	const handleOnClick = (val: any, id: number) => {
		if (id == 0) {
			logAnalyticsEvent({
				trigger_point: 'Clicks Linked Bank Accounts',
				Product: 'AutoPayUPI',
				Flow: 'Setting',
				Screen: 'UPI_Settings',
				Module: 'CTA_Cards',
				Element: 'CTA',
				Action: 'Tapped',
				ctaType: 'linkedBankAccounts',
			});
			history.push('/account/bank-list');
			// } else if (id == 1) {
			// 	logAnalyticsEvent({
			// 		trigger_point: 'Clicks Approve To Pay',
			// 		Product: 'AutoPayUPI',
			// 		Flow: 'Setting',
			// 		Screen: 'UPI_Settings',
			// 		Module: 'CTA_Cards',
			// 		Element: 'CTA',
			// 		Action: 'Tapped',
			// 		ctaType: 'approveToPay',
			// 	});
			// 	history.push('/account/approve-to-pay');
		} else if (id == 1) {
			logAnalyticsEvent({
				trigger_point: 'Clicks Transaction History',
				Product: 'AutoPayUPI',
				Flow: 'Setting',
				Screen: 'UPI_Settings',
				Module: 'CTA_Cards',
				Element: 'CTA',
				Action: 'Tapped',
				ctaType: 'transactionHistory',
			});
			history.push('/account/transaction-list');
		} else if (id == 2) {
			logAnalyticsEvent({
				trigger_point: 'Clicks Transaction History',
				Product: 'AutoPayUPI',
				Flow: 'Setting',
				Screen: 'UPI_Settings',
				Module: 'CTA_Cards',
				Element: 'CTA',
				Action: 'Tapped',
				ctaType: 'manageAutoPay',
			});
			history.push('/account/manage-auto-pay');
		} else if (id == 3) {
			logAnalyticsEvent({
				trigger_point: 'Clicks Delinks BharatPe UPI',
				Product: 'AutoPayUPI',
				Flow: 'Setting',
				Screen: 'UPI_Settings',
				Module: 'CTA_Cards',
				Element: 'CTA',
				Action: 'Tapped',
				ctaType: 'delinksBharatpeUpi',
			});
			if (auto_pay_active == true) handleDelinkUPIAccountDeniedPrimaryButtonClick(true);
			else setShowDelinkBharatPeUpiModal(true);
		}
	};

	const profile_list = [
		{
			title: languageData.LINKED_BANK_ACCOUNTS,
			leftContentAlignTop: true,
			leftIcon: {
				icon: BankIcon,
				height: '30px',
				width: '30px',
			},
		},
		// {
		// 	title: languageData.APPROVE_TO_PAY,
		// 	leftContentAlignTop: true,
		// 	leftIcon: {
		// 		icon: circleCheck,
		// 		height: '30px',
		// 		width: '30px',
		// 	},
		// },
		{
			title: languageData.TRANSACTION_HISTORY,
			leftContentAlignTop: true,
			leftIcon: {
				icon: transactionHistoryIcon,
				height: '30px',
				width: '30px',
			},
		},
		{
			title: languageData.MANAGE_AUTO_PAY,
			leftContentAlignTop: true,
			leftIcon: {
				icon: autoPayIcon,
				height: '30px',
				width: '30px',
			},
		},
		{
			title: 'Delink BharatPe UPI',
			leftContentAlignTop: true,
			leftIcon: {
				icon: linkBroken,
				height: '30px',
				width: '30px',
			},
		},
	];

	const onCopyClick = () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks Copy VPA button',
			Product: 'AutoPayUPI',
			Flow: 'Setting',
			Screen: 'UPI_Settings',
			Module: 'VPA_card',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'copyVPA',
		});
		copyToClipboard({ code: va, lable: 'user-vpa', msgText: 'VPA Copied' });
	};

	const backEventAction = () => {
		logAnalyticsEvent({
			trigger_point: `Clicks on back button`,
			Product: 'AutoPayUPI',
			Flow: 'Setting',
			Screen: 'UPI_Settings',
			Action: 'Tapped',
			source: 'appHeader',
		});
	};

	useEffect(() => {
		customSubScribeBackButton(() => {
			onBack();
		});
	}, [history]);

	const onBack = () => {
		const appversion = getURLParameter(window.location.href, 'appversion');
		if (!isIOS() && Number(appversion) >= 716) {
			openDeepLinkWithCallback('bharatpe://native/profile');
		} else {
			const locationUrl = window.location.href;
			let redirectDeeplink = '';
			if (locationUrl.includes('bp-pg.bharatpe.io')) redirectDeeplink = MODULE_DEEPLINKS.PROFILE_DEV;
			else if (locationUrl.includes('bp-pg-uat.bharatpe.in')) redirectDeeplink = MODULE_DEEPLINKS.PROFILE_UAT;
			else if (locationUrl.includes('bp-pg-uat1.bharatpe.in')) redirectDeeplink = MODULE_DEEPLINKS.PROFILE_QA;
			else if (locationUrl.includes('localhost')) redirectDeeplink = MODULE_DEEPLINKS.PROFILE_QA;
			else redirectDeeplink = MODULE_DEEPLINKS.PROFILE_PROD;
			openDeepLinkWithCallback(redirectDeeplink);
		}
	};

	const handleDelinkBharatPeUpiConfirmationClick = async () => {
		setShowDelinkBharatPeUpiModal(false);
		setShowDelinkBharatPeUpiLoadingModal(true);
		try {
			await DelinkBharatPeUPI(profile_id);
			setDelinkBharatPeUpiStatus(true);
			setShowDelinkBharatPeUpiLoadingModal(false);
			setShowDelinkBharatPeUpiSuccessModal(true);
		} catch {
			setShowDelinkBharatPeUpiLoadingModal(false);
			setShowDelinkBharatPeUpiFailureModal(true);
		} finally {
			setStartInterval(true);
		}
	};
	const handleDelinkBharatPeUpiCancelClick = () => {
		setShowDelinkBharatPeUpiModal(false);
	};
	return userDetails?.loading || merchantInfo?.loading ? (
		<Loader loading />
	) : (
		<PageLayout className="white-background ">
			<>
				<AppHeader title={languageData.UPI_SETTINGS} backEventAction={backEventAction} leftIconAction={onBack} />
				<AllModals upiOnboardingSource={ONBOARDING_REDIRECTION_PAGE.PROFILE} />
				<div className="mx5 mt6">
					<Card className="p4 flex flex-column">
						<div className="flex flex-row flex-center">
							<div className="br3 mr3">
								<img src={UPILogo} loading="lazy" height={50} width={50} />
							</div>
							<div>
								<Typography variant="Regular500" className="text-left">
									{merchantName !== '' ? merchantName : 'BharatPe Merchant'}
								</Typography>
								<div className="flex flex-row flex-center dashed-border br1 px2 py1 mt2" onClick={() => onCopyClick()}>
									<Typography variant="Light100" className="text-left grey mr2">
										{va}
									</Typography>
									<Icon icon={copyIcon} height={16} width={16} />
								</div>
							</div>
						</div>
					</Card>
					<List list={profile_list} className={'mt6'} onClick={(val: any, id: number) => handleOnClick(val, id)} />
				</div>

				<BottomSheet visible={showDelinkBharatPeUpiModal} showCloseButton={false} rounded>
					<div className="p4 flex flex-column">
						<Icon icon={WarningRounded} className="mr2 failed-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2 red-text-color">
							Delink BharatPe UPI?
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb4">
							Are you sure you want to delink BharatPe UPI?{' '}
						</Typography>
						<div className="flex flex-row mt4">
							<Button
								onClick={handleDelinkBharatPeUpiConfirmationClick}
								color="danger"
								variant="outlined"
								className="mr2 width-50">
								UNLINK
							</Button>

							<Button onClick={handleDelinkBharatPeUpiCancelClick} className="width-50">
								CANCEL
							</Button>
						</div>
					</div>
				</BottomSheet>
				<BottomSheet visible={showDelinkBharatPeUpiLoadingModal} showCloseButton={false} rounded>
					<div className="p4 flex flex-column">
						<div className="flex flex-justify-center flex-center content-center">
							<img src={LoaderImage} alt="loader" className="loader white-background" width={60} height={60} />
						</div>
						<Typography variant="Bold500" className="mt2 text-center">
							Processing
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb16 text-center">
							Please Wait
						</Typography>
						<div className="upi-powered-sticky">
							<UpiPoweredBy />
						</div>
					</div>
				</BottomSheet>
				<BottomSheet visible={showDelinkBharatPeUpiSuccessModal} showCloseButton={false} rounded>
					<div className="p4 flex flex-column">
						<Icon icon={CheckCircle} className="mr2 success-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2">
							Your UPI account was successfully deleted!
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb16">
							Redirecting in {countdownTimer} secs...
						</Typography>
						<div className="upi-powered-sticky">
							<UpiPoweredBy />
						</div>
					</div>
				</BottomSheet>
				<BottomSheet visible={showDelinkBharatPeUpiFailureModal} showCloseButton={false} rounded>
					<div className="p4 flex flex-column">
						<Icon icon={Error} className="mr2 failed-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2 red-text-color">
							Your UPI account was not deleted due to some error!
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb16">
							Redirecting in {countdownTimer} secs...
						</Typography>
						<div className="upi-powered-sticky">
							<UpiPoweredBy />
						</div>
					</div>
				</BottomSheet>
				<BottomSheet visible={showDelinkUPIAccountDeniedModal} showCloseButton={false} rounded>
					<div className="p4 flex flex-column">
						<Icon icon={WarningRounded} className="mr2 failed-logo" width={40} height={40} />
						<Typography variant="Bold500" className="mt2">
							Not Allowed!
						</Typography>
						<Typography variant="Regular200" className="grey mt1 mb4">
							You cannot delink this bank account because it is linked to Autopay payments for an ongoing loan.
						</Typography>
						<div className="flex flex-row mt4">
							<Button onClick={() => handleDelinkUPIAccountDeniedPrimaryButtonClick(false)} className="width-100">
								OKAY
							</Button>
						</div>
					</div>
				</BottomSheet>
			</>
		</PageLayout>
	);
};
export default UPISettings;
